import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PageTracker from './components/PageTracker';
import FloatingContactToggle from './components/FloatingContactToggle';
import Home from './pages/Home';
import AboutTheJournal from './pages/AboutTheJournal';
import AimsAndScope from './pages/AimsAndScope';
import EditorialBoardPage from './pages/EditorialBoardPage';
import IssuesPage from './pages/IssuesPage';
import ArticleDetail from './pages/ArticleDetail';
import AuthorGuidelinesPage from './pages/AuthorGuidelinesPage';
import PeerReviewPage from './pages/PeerReviewPage';
import PublicationEthicsPage from './pages/PublicationEthicsPage';
import Contact from './components/Contact';
import Upload from './pages/Upload';
import Tracking from './pages/Tracking';
import DynamicBladePage from './pages/DynamicBladePage';
import Admin from './pages/Admin';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Copyright from './pages/Copyright';
import TechTeam from './pages/TechTeam';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import CallForPapersPage from './pages/CallForPapersPage';

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  // Open every new page at the top (links to a #section are scrolled by the page itself)
  useEffect(() => {
    if (location.hash) return undefined;
    const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    toTop();
    // Again once the header has grown back to its full height (it shrinks while scrolled)
    const timer = setTimeout(toTop, 120);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col">
      <PageTracker />
      {!isAdmin && <Header />}
      <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Dedicated academic pages matching reference mockup */}
            <Route path="/about" element={<AboutTheJournal />} />
            <Route path="/about-us" element={<AboutTheJournal />} />
            <Route path="/aims-and-scope" element={<AimsAndScope />} />
            <Route path="/aims-scope" element={<AimsAndScope />} />
            <Route path="/editorial-board" element={<EditorialBoardPage />} />
            <Route path="/current-issue" element={<IssuesPage />} />
            <Route path="/archives" element={<IssuesPage />} />
            <Route path="/call-for-papers" element={<CallForPapersPage />} />

            {/* Author guidelines and peer review dedicated academic pages */}
            <Route path="/information-for-authors" element={<AuthorGuidelinesPage />} />
            <Route path="/author-guidelines" element={<AuthorGuidelinesPage />} />
            <Route path="/submission-guidelines" element={<PeerReviewPage />} />
            <Route path="/peer-review" element={<PeerReviewPage />} />
            <Route path="/publication-ethics" element={<PublicationEthicsPage />} />
            <Route path="/ethics" element={<PublicationEthicsPage />} />

            {/* Dedicated canonical article route */}
            <Route path="/journal/:volParam/:issParam/:articleId" element={<ArticleDetail />} />
            <Route path="/journal/:volParam/:issParam/:articleId/*" element={<ArticleDetail />} />

            {/* Author and institutional forms */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/submit-manuscript" element={<Upload />} />
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/admin" element={<Admin />} />

            {/* Compliance and policies */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/copyright" element={<Copyright />} />
            <Route path="/tech-team" element={<TechTeam />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/disclaimer" element={<Disclaimer />} />

            {/* Dynamic Blade Pages for other guideline submenus */}
            <Route path="/:bladeKey" element={<DynamicBladePage />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
        {!isAdmin && <FloatingContactToggle />}
      </div>
  );
}

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppContent />
    </Router>
  );
}

export default App;
